import confirmationPageMixin from "@/pages/confirmation/mixin";

export default {
  mixins: [confirmationPageMixin],
};
